import type { TFunction } from 'i18next';

// Seeded role codes (schema core.role). Display names are i18n keys `role.<CODE>` (EN = the seed names); unknown codes render as the code.
export const ROLE_CODES = [
  'STOREKEEPER',
  'INSPECTOR',
  'HEAD_STORES',
  'HEAD_WTY_OH',
  'HEAD_TECH_SVC',
  'HEAD_SECTION',
  'DIRECTOR_DELEGATE',
  'DIRECTOR',
  'BUYER',
  'ENGINEER',
  'TECH_RECORDS',
  'FINANCE_VIEW',
  'ADMIN',
  'AUDITOR',
  'SUPERADMIN',
] as const;

export type RoleCode = (typeof ROLE_CODES)[number];

const KNOWN = new Set<string>(ROLE_CODES);

export const roleName = (t: TFunction, code: string): string => (KNOWN.has(code) ? t(`role.${code}`) : code);

export const roleNames = (t: TFunction, codes: readonly string[]): string => codes.map((c) => roleName(t, c)).join(' · ');
